const ENDPOINT = '/oxid-proxy/graphql';

async function request(query, variables = {}) {
    const response = await fetch(ENDPOINT, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query, variables }),
    });

    if (!response.ok) {
        throw new Error(`GraphQL request failed: ${response.statusText}`);
    }

    const json = await response.json();

    if (json.errors?.length) {
        throw new Error(json.errors[0].message);
    }

    return json.data;
}

export function query(query, variables) {
    return request(query, variables);
}

export function mutate(mutation, variables) {
    return request(mutation, variables);
}
